module.exports = __webpack_public_path__ + "img/TR-1440.d2660c45.jpg";